// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2pefA","content":"GlobalSearch_content__fn5g0"};